import { action, makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'
import Reservation from './reservationStore'

class OrderStore {
    memberOrders = []
    memberOrderCount = 0
    orders = []
    orderCount = 0
    order = undefined

    constructor() {
        makeAutoObservable(this)
    }

    listMemberOrders = flow(function* (userId, search) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.memberListOrders(token, userId, 20, 0, search)
            const { orders, count } = response.data
            this.memberOrders = orders
            this.memberOrderCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreMemberOrders = flow(function* (skip, userId, search) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.memberListOrders(token, userId, 20, skip, search)
            const { orders, count } = response.data
            this.memberOrders = _.union(this.orders, orders)
            this.memberOrderCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listOrders = flow(function* (search) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listOrders(token, 20, 0, search)
            const { orders, count } = response.data
            this.orders = orders
            this.orderCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreOrders = flow(function* (skip, search) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listOrders(token, 20, skip, search)
            const { orders, count } = response.data
            this.orders = _.union(this.orders, orders)
            this.orderCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    getOrder = flow(function* (orderId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.getOrder(token, orderId)
            this.order = response.data
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateOrderStatus = flow(function* (orderId, status) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.updateOrderStatus(token, orderId, status)
            if (status == 'DELETED') {
                this.orders = this.orders.filter((f) => { return f._id !== orderId })
                this.memberOrders = this.memberOrders.filter((f) => { return f._id !== orderId })
                this.orderCount = this.orderCount - 1
                this.memberOrders = this.memberOrderCount - 1
            }
            const aindex = this.orders.findIndex((f) => { return f._id == orderId })
            if (aindex !== -1) {
                this.orders[aindex] = response.data
            }
            const bindex = this.memberOrders.findIndex((f) => { return f._id == orderId })
            if (bindex !== -1) {
                this.memberOrders[bindex] = response.data
            }
            this.order = response.data
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateReservationStatus = flow(function* (orderId, reservationId, status) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.updateReservationStatus(token, orderId, reservationId, status)
            Reservation.updateReservationStatus(reservationId, status)
            const aindex = this.orders.findIndex((f) => { return f._id == orderId })
            if (aindex !== -1) {
                this.orders[aindex] = response.data
            }
            const bindex = this.memberOrders.findIndex((f) => { return f._id == orderId })
            if (bindex !== -1) {
                this.memberOrders[bindex] = response.data
            }
            this.order = response.data
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })
}

export default new OrderStore()